var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Boton from "../../common/Boton";
var InfoModal = function (_a) {
    var data = _a.data;
    var title = data.title, description = data.description, buttonMessage = data.buttonMessage, closeModal = data.closeModal;
    return (React.createElement(InfoModalContainer, null,
        React.createElement("h3", null, title),
        React.createElement("p", null, description),
        React.createElement(Boton, { texto: buttonMessage, handleOnClick: closeModal })));
};
export default InfoModal;
var InfoModalContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n\n  button {\n    font-size: 1rem;\n    margin: 0;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n\n  button {\n    font-size: 1rem;\n    margin: 0;\n  }\n"])));
var templateObject_1;
